import { render, staticRenderFns } from "./MailSupressionList.vue?vue&type=template&id=67a8ee4a"
import script from "./MailSupressionList.vue?vue&type=script&lang=js"
export * from "./MailSupressionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports